import * as React from 'react';
import MemberClosetContainer from 'containers/member/MemberClosetContainer';

const MemberCloset = () => {
  return <MemberClosetContainer />;
};

export default MemberCloset;
